/**
 * Opciones de turnos del modal de planificación con IA, de menos a más flexible.
 * «Menos flexible» retrocede y «Más ajuste» avanza por esta misma lista.
 */

export const FRACTION_SHIFT_OPTIONS = [
	{
		value: "false",
		labelKey: "magicPlan.optFullShiftsShort",
		captionKey: "magicPlan.optShiftDirect",
		segments: [true],
	},
	{
		value: "60",
		labelKey: "magicPlan.optFractions60Short",
		captionKey: "magicPlan.optShiftFlexible",
		segments: [true, true, false, false],
	},
	{
		value: "30",
		labelKey: "magicPlan.optFractions30Short",
		captionKey: "magicPlan.optShiftFine",
		segments: [true, true, true, false],
	},
	{
		value: "15",
		labelKey: "magicPlan.optFractions15Short",
		captionKey: "magicPlan.optShiftMax",
		segments: [true, true, true, true],
	},
];

export function stepFractionShiftValue(current, direction) {
	const index = FRACTION_SHIFT_OPTIONS.findIndex(
		(option) => option.value === String(current)
	);
	const safeIndex = index === -1 ? 0 : index;
	const nextIndex = safeIndex + direction;

	if (nextIndex < 0 || nextIndex >= FRACTION_SHIFT_OPTIONS.length) {
		return FRACTION_SHIFT_OPTIONS[safeIndex].value;
	}

	return FRACTION_SHIFT_OPTIONS[nextIndex].value;
}
